import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const K8DriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.syncK8',
        popover: {
          title: 'Sync Cluster Information',
          description:
            'Click here to sync the latest data from the cluster. This action updates the cluster’s information, including node status, resource allocation, and other critical details.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.refreshK8',
        popover: {
          title: 'Refresh Cluster Status',
          description:
            'Use this button to refresh the status of your cluster. It will reload the page and display any recent changes made to the cluster configuration or resources.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.retireK8',
        popover: {
          title: 'Retire Cluster',
          description:
            'Click here to retire the Kubernetes cluster. This action will decommission the cluster, marking it as inactive while keeping its configuration and logs available for future reference.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createK8',
        popover: {
          title: 'Create New Kubernetes Cluster',
          description:
            'Click this button to create a new Kubernetes cluster. You will need to specify a name, select a region, configure the CNI (network interface), and assign the cluster to a public and private network.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.tableDataK8',
        popover: {
          title: 'Cluster Resources Overview',
          description:
            'This table shows the detailed resources within the Kubernetes cluster, including nodes, pods, IP addresses, and their roles (e.g., master, worker). Use this table to monitor the health and status of the resources within your cluster.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};

export default K8DriverObj;
